export const logRequestResponseOptions = [
  { value: '', label: 'Todos' },
  { value: 1, label: 'Sucesso' },
  { value: 0, label: 'Falha' },
];